import { FilterSection } from "../../../data-model/filterValues";
import { PharmaStpFileModel } from "../../../data-model/nycbsPharmaOrder";
import { allPaStatusBucketOptions } from "./filterOptions/paStatusBucketFilterOptions";
import { allPaStatusOptions } from "./filterOptions/paStatusFilterOptions";

/** Sidebar filter values for the Biosimilar column. */
export enum AsteraBiosimilarFilterValue {
  YES = "yes",
  INITIATED = "initiated",
  NULL = "null",
}

/** Biosimilar filter options aligned with table badge labels. */
export const allBiosimilarFilterOptions = [
  { label: "Yes", value: AsteraBiosimilarFilterValue.YES },
  { label: "Initiated", value: AsteraBiosimilarFilterValue.INITIATED },
  { label: "Null", value: AsteraBiosimilarFilterValue.NULL },
];

export enum AsteraOncologyExternalFilterKeys {
  DOW = "dumped_at",
  PA_STATUS = "pa_status",
  PA_STATUS_BUCKET = "pa_status_bucket",
  BIOSIMILAR = "biosimilar",
}

export const createFilterForDOW = (
  data: PharmaStpFileModel[],
): FilterSection => {
  return {
    id: AsteraOncologyExternalFilterKeys.DOW,
    label: "DOW",
    options: [],
    type: "date",
  };
};

export const createFilterForPaStatus = (
  data: PharmaStpFileModel[],
): FilterSection => {
  return {
    id: AsteraOncologyExternalFilterKeys.PA_STATUS,
    label: "Outcome",
    options: allPaStatusOptions,
    type: "string",
  };
};

export const createFilterForPaStatusBucket = (
  data: PharmaStpFileModel[],
): FilterSection => {
  return {
    id: AsteraOncologyExternalFilterKeys.PA_STATUS_BUCKET,
    label: "Outcome Class",
    options: allPaStatusBucketOptions,
    type: "string",
  };
};

export const createFilterForBiosimilar = (
  _data: PharmaStpFileModel[],
): FilterSection => {
  return {
    id: AsteraOncologyExternalFilterKeys.BIOSIMILAR,
    label: "Biosimilar",
    options: allBiosimilarFilterOptions,
    type: "string",
  };
};

export const createAllFilterSections = (
  data: PharmaStpFileModel[],
): FilterSection[] => {
  if (!data || data.length === 0) {
    return [];
  }

  return [
    createFilterForDOW(data),
    createFilterForPaStatus(data),
    createFilterForPaStatusBucket(data),
    createFilterForBiosimilar(data),
  ];
};
